import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/me/")({
	beforeLoad: () => {
		throw redirect({ to: "/me/$tab", params: { tab: "details" } });
	},
});
